
export const UserRoles = {
  admin: 'admin',
  employee: 'employee',
};

export const inputTypes = {
  text: 'text',
  number: 'number',
  email: 'email',
  password: 'password',
  select: 'select',
  date: 'date',
  timePicker: 'timePicker',
  multiple: 'multiple',
  usersSelect: 'users-select',
  projectsSelect: 'projects-select',
  timeAmountPicker: 'timeAmountPicker',
};
